"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHoursAndMinutesStringFromFractionalHours = exports.isOvernight = exports.deriveDate = exports.setDateToTimeMoment = exports.formatDateTime = exports.dateTime = void 0;
const moment_timezone_1 = __importStar(require("moment-timezone"));
class DateTime {
    dateFormat = 'MM/DD/YY';
    timeFormat = 'HH:mm';
    constructor(type = 'default') {
        this.changeFormat(type);
    }
    changeFormat(format) {
        if (format === 'inverted') {
            this.dateFormat = 'MM/DD/YY';
            this.timeFormat = 'h:mma';
        }
    }
    date(date, tz) {
        return (0, exports.formatDateTime)(date, this.dateFormat, tz);
    }
    time(date, tz) {
        return (0, exports.formatDateTime)(date, this.timeFormat, tz);
    }
    custom(date, format, tz) {
        return (0, exports.formatDateTime)(date, format, tz);
    }
}
exports.default = DateTime;
exports.dateTime = new DateTime();
const formatDateTime = (dateTime, format, timezone) => {
    if (!dateTime) {
        return '';
    }
    if (timezone) {
        return (0, moment_timezone_1.tz)(dateTime, timezone).format(format);
    }
    return moment_timezone_1.default.parseZone(dateTime).format(format);
};
exports.formatDateTime = formatDateTime;
const setDateToTimeMoment = (date, time, ignoreDateTz = true) => {
    const dateMoment = ignoreDateTz ? moment_timezone_1.default.utc(date) : (0, moment_timezone_1.default)(date);
    const timeMoment = (0, moment_timezone_1.default)(time);
    const dateTimeMoment = timeMoment.clone();
    dateTimeMoment.tz(dateMoment.tz());
    dateTimeMoment.set('year', dateMoment.year());
    dateTimeMoment.set('month', dateMoment.month());
    dateTimeMoment.set('date', dateMoment.date());
    if (dateTimeMoment.isValid()) {
        return dateTimeMoment;
    }
    else {
        throw new Error('Invalid datetime');
    }
};
exports.setDateToTimeMoment = setDateToTimeMoment;
const deriveDate = (job, time, mode) => {
    if (job.location && job.location.timezone_lookup) {
        const startMoment = (0, moment_timezone_1.default)(job.current_starts_time).tz(job.location.timezone_lookup);
        const endMoment = (0, moment_timezone_1.default)(job.current_ends_time).tz(job.location.timezone_lookup);
        if (startMoment.isAfter(endMoment)) {
            throw new Error('current_starts_time is after current_ends_time');
        }
        else if (endMoment.diff(startMoment, 'days') > 1) {
            throw new Error('current_starts_time and current_ends_time are more than one day apart');
        }
        const timeAtStartDate = (0, exports.setDateToTimeMoment)(startMoment, time, false);
        const timeAtEndDate = (0, exports.setDateToTimeMoment)(endMoment, time, false);
        if (mode === 'clock_out') {
            if (timeAtStartDate.isBefore(startMoment, 'minute')) {
                return startMoment.clone().add(1, 'day').format('YYYY-MM-DD');
            }
        }
        else {
            if (timeAtEndDate.isAfter(endMoment, 'minute')) {
                return endMoment.clone().subtract(1, 'day').format('YYYY-MM-DD');
            }
        }
        if (timeAtStartDate.isBetween(startMoment, endMoment)) {
            return timeAtStartDate.format('YYYY-MM-DD');
        }
        if (timeAtEndDate.isBetween(startMoment, endMoment)) {
            return timeAtEndDate.format('YYYY-MM-DD');
        }
        return mode === 'clock_in' ? startMoment.format('YYYY-MM-DD') : endMoment.format('YYYY-MM-DD');
    }
    return null;
};
exports.deriveDate = deriveDate;
const isOvernight = (job) => {
    if (job.location && job.location.timezone_lookup) {
        return !moment_timezone_1.default
            .tz(job.current_starts_time, job.location.timezone_lookup)
            .isSame(moment_timezone_1.default.tz(job.current_ends_time, job.location.timezone_lookup), 'date');
    }
    throw new Error('Job is missing location.timezone_lookup');
};
exports.isOvernight = isOvernight;
const getHoursAndMinutesStringFromFractionalHours = (hours, readable) => {
    const displayHours = Math.floor(hours);
    const displayMinutes = Math.floor((hours - displayHours) * 60);
    return readable
        ? `${displayHours} hours${displayMinutes ? ` ${displayMinutes} minutes` : ''}`
        : `${displayHours}h${displayMinutes ? ` ${displayMinutes}m` : ''}`;
};
exports.getHoursAndMinutesStringFromFractionalHours = getHoursAndMinutesStringFromFractionalHours;
